import React, { Component } from "react";
import { Timeline, TimelineItem } from "vertical-timeline-component-for-react";
import Collapsible from "react-collapsible";
import {
  MomentDateFormat,
  getStatusIcon,
  getDateStatusColor,
  TimelineItemDateText,
  IsOpenDescript,
} from "./CustomFuntion";
import "../../styles/timelineItem.css";
import "../../styles/timeline.css";

import Moment from "moment";

import { Link } from "office-ui-fabric-react";

interface IState {
  completedItems: any;
  olderItems: any;
  currentItems: any;
  upcomingItems: any;
  currentText: string;
  documentURL: string;
  currentDate: Date;
}

class completedtask extends Component<{}, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      currentDate: new Date(),
      completedItems: [],
      olderItems: [],
      upcomingItems: [],
      currentItems: [],
      currentText: "",
      documentURL: "",
    };
  }
  componentDidMount() {
    this.getAPI().then((apiRes: any) => {
      let api = JSON.parse(apiRes);
      this.setState(
        {
          documentURL: api.matterdetail,
        },
        () => {
          this._generateOlderItems(this.props.items);
          this._generateCurrentItems(this.props.items);
          this._generateUpcomingItems(this.props.items);
          this._generateCompleted(this.props.items);
        },
      );
    });
  }

  getAPI() {
    return new Promise((resolve) => {
      resolve(localStorage.getItem("api"));
    });
  }

  _generateOlderItems(currItem: any) {
    let tempOverdue = [];
    for (let c = 0; c < currItem.length; c++) {
      if (currItem[c].data.event.status === "Complete") {
        let itemDate = Moment(
          currItem[c].data.event.dueDate,
          "YYYY-MM-DD",
        ).toDate();

        if (itemDate < this.state.currentDate) {
          if (itemDate.getFullYear() === this.state.currentDate.getFullYear()) {
            if (itemDate.getMonth() != this.state.currentDate.getMonth()) {
              tempOverdue.push(currItem[c]);
            }
          } else {
            tempOverdue.push(currItem[c]);
          }
        }
      }
    }
    this.setState({
      olderItems: tempOverdue,
    });
  }

  _generateCurrentItems(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      if (currItem[c].data.event.status === "Complete") {
        let itemDate = Moment(
          currItem[c].data.event.dueDate,
          "YYYY-MM-DD",
        ).toDate();
        if (
          itemDate.getMonth() === this.state.currentDate.getMonth() &&
          itemDate.getFullYear() === this.state.currentDate.getFullYear()
        ) {
          tempUpcoming.push(currItem[c]);
        }
      }
    }
    this.setState({
      currentItems: tempUpcoming,
    });
  }

  _generateUpcomingItems(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      if (currItem[c].data.event.status === "Complete") {
        let itemDate = Moment(
          currItem[c].data.event.dueDate,
          "YYYY-MM-DD",
        ).toDate();
        if (itemDate > this.state.currentDate) {
          if (itemDate.getFullYear() === this.state.currentDate.getFullYear()) {
            if (itemDate.getMonth() != this.state.currentDate.getMonth()) {
              tempUpcoming.push(currItem[c]);
            }
          } else {
            tempUpcoming.push(currItem[c]);
          }
        }
      }
    }

    this.setState({
      upcomingItems: tempUpcoming,
    });
  }

  _generateCompleted(currItem: any) {
    let tempCompleted = [];
    for (let c = 0; c < currItem.length; c++) {
      if (currItem[c].data.event.status === "Complete") {
        tempCompleted.push(currItem[c]);
      }
    }

    this.setState({
      completedItems: tempCompleted,
    });
  }

  formatDate(date: any) {
    var parts = date.split("-");
    return new Date(parts[0], parts[1] - 1, parts[2].substring(0, 2));
  }

  generateOlderItems() {
    this.state.olderItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.olderItems.map((items: any) => {
      return (
        <TimelineItem
          key={items.id}
          dateText={TimelineItemDateText(items.data.event.dueDate)}
          dateInnerStyle={{
            background: getDateStatusColor(items.data.event.dueDate),
          }}
          style={{ color: getStatusIcon(items.data.event.status) }}
        >
          <Collapsible
            className={"Collapsible-TimeLineItem"}
            trigger={items.data.event.task}
            open={IsOpenDescript(items.data.event.dueDate)}
            autoFocus={IsOpenDescript(items.data.event.dueDate)}
          >
            <Link
              type="submit"
              href={
                this.state.documentURL +
                "/Matter?matterCode=" +
                items.data.matterCode +
                "#/Workflow"
              }
              target="_blank"
            >
              {items.data.matterCode}
            </Link>
            {` - ${items.data.description}`}
            <hr className="line-item" />
            {items.data.event.assignTo.length > 0 ? (
              <b className="assignToLabel">{"AssignTo: "} </b>
            ) : (
              ""
            )}
            {items.data.event.assignTo.map((assignto: any, index: any) => {
              return <i key={items.id + index}>{assignto.name}, </i>;
            })}
          </Collapsible>
        </TimelineItem>
      );
    });
  }

  generateCurrentItems() {
    this.state.currentItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.currentItems.map((items: any) => {
      return (
        <TimelineItem
          key={items.id}
          dateText={TimelineItemDateText(items.data.event.dueDate)}
          dateInnerStyle={{
            background: getDateStatusColor(items.data.event.dueDate),
          }}
          style={{ color: getStatusIcon(items.data.event.status) }}
        >
          <Collapsible
            className={"Collapsible-TimeLineItem"}
            trigger={items.data.event.task}
            open={IsOpenDescript(items.data.event.dueDate)}
            autoFocus={IsOpenDescript(items.data.event.dueDate)}
          >
            <Link
              type="submit"
              href={
                this.state.documentURL +
                "/Matter?matterCode=" +
                items.data.matterCode +
                "#/Workflow"
              }
              target="_blank"
            >
              {items.data.matterCode}
            </Link>
            {` - ${items.data.description}`}
            <hr className="line-item" />
            {items.data.event.assignTo.length > 0 ? (
              <b className="assignToLabel">{"AssignTo: "} </b>
            ) : (
              ""
            )}
            {items.data.event.assignTo.map((assignto: any, index: any) => {
              return <i key={items.id + index}>{assignto.name}, </i>;
            })}
          </Collapsible>
        </TimelineItem>
      );
    });
  }

  generateUpcomingItems() {
    this.state.upcomingItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.upcomingItems.map((items: any) => {
      return (
        <TimelineItem
          key={items.id}
          dateText={TimelineItemDateText(items.data.event.dueDate)}
          dateInnerStyle={{
            background: getDateStatusColor(items.data.event.dueDate),
          }}
          style={{ color: getStatusIcon(items.data.event.status) }}
        >
          <Collapsible
            className={"Collapsible-TimeLineItem"}
            trigger={items.data.event.task}
            open={IsOpenDescript(items.data.event.dueDate)}
            autoFocus={IsOpenDescript(items.data.event.dueDate)}
          >
            <Link
              type="submit"
              href={
                this.state.documentURL +
                "/Matter?matterCode=" +
                items.data.matterCode +
                "#/Workflow"
              }
              target="_blank"
            >
              {items.data.matterCode}
            </Link>
            {` - ${items.data.description}`}
            <hr className="line-item" />
            {items.data.event.assignTo.length > 0 ? (
              <b className="assignToLabel">{"AssignTo: "} </b>
            ) : (
              ""
            )}
            {items.data.event.assignTo.map((assignto: any, index: any) => {
              return <i key={items.id + index}>{assignto.name}, </i>;
            })}
          </Collapsible>
        </TimelineItem>
      );
    });
  }

  generateCompletedItems() {
    this.state.completedItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });

    return this.state.completedItems.map((items: any) => {
      return (
        <TimelineItem
          key={items.id}
          dateText={TimelineItemDateText(items.data.event.dueDate)}
          dateInnerStyle={{
            background: getDateStatusColor(items.data.event.dueDate),
          }}
          style={{ color: getStatusIcon(items.data.event.status) }}
        >
          <Collapsible
            className={"Collapsible-TimeLineItem"}
            trigger={items.data.event.task}
            open={IsOpenDescript(items.data.event.dueDate)}
          >
            <Link
              type="submit"
              href={
                this.state.documentURL +
                "/Matter?matterCode=" +
                items.data.matterCode +
                "#/Workflow"
              }
              target="_blank"
            >
              {items.data.matterCode}
            </Link>
            {` - ${items.data.description}`}
            <hr className="line-item" />
            {items.data.event.assignTo.length > 0 ? (
              <b className="assignToLabel">{"AssignTo: "} </b>
            ) : (
              ""
            )}
            {items.data.event.assignTo.map((assignto: any, index: any) => {
              return <i key={items.id + index}>{assignto.name}, </i>;
            })}
          </Collapsible>
        </TimelineItem>
      );
    });
  }

  public render() {
    return (
      <div className={"complete-task-view ms-motion-slideDownIn"}>
        {/* <Collapsible
          id="complete"
          className="upcoming-text"
          triggerOpenedClassName="upcoming-text-span"
          trigger={"Completed Task (" + this.state.completedItems.length + ")"}
          open={true}
          triggerDisabled={true}
        >
          {this.state.completedItems.length > 0 ? (
            <Timeline lineColor={"#ddd"} animations={true}>
              {this.generateCompletedItems()}
            </Timeline>
          ) : (
              ""
            )}
        </Collapsible> */}
        <Collapsible
          id="older"
          className="upcoming-text"
          trigger={"Older (" + this.state.olderItems.length + ")"}
          open={false}
          triggerOpenedClassName="upcoming-text-span"
        >
          {this.state.olderItems.length > 0 ? (
            <Timeline lineColor={"#ddd"} animations={true}>
              {" "}
              {this.generateOlderItems()}{" "}
            </Timeline>
          ) : (
            ""
          )}
        </Collapsible>
        <Collapsible
          id="current-month"
          className="upcoming-text"
          trigger={
            Moment(this.state.currentDate).format("MMMM").toString() +
            "  (" +
            this.state.currentItems.length +
            ")"
          }
          open={true}
          triggerOpenedClassName="upcoming-text-span"
        >
          {this.state.currentItems.length > 0 ? (
            <Timeline lineColor={"#ddd"} animations={true}>
              {this.generateCurrentItems()}{" "}
            </Timeline>
          ) : (
            ""
          )}
        </Collapsible>
        <Collapsible
          id="other-upcoming"
          className="upcoming-text"
          trigger={"Upcoming  (" + this.state.upcomingItems.length + ")"}
          open={false}
          triggerOpenedClassName="upcoming-text-span"
        >
          {this.state.upcomingItems.length > 0 ? (
            <Timeline lineColor={"#ddd"} animations={true}>
              {this.generateUpcomingItems()}{" "}
            </Timeline>
          ) : (
            ""
          )}
        </Collapsible>
      </div>
    );
  }
}

export default completedtask;
